import React from 'react';
import buttonImage from '../buttonimage.webp'; // Import button image
import backgroundImage from '../background.webp'; // Import background image
import cardBackgroundImage from '../cardbackground.webp'; // Import card background image

function Subconscious({ goBack, goHome, handleSaveProgress }) {
    const handleSave = async () => {
        if (typeof handleSaveProgress === 'function') {
            await handleSaveProgress('subconscious', null, false);
            alert('Session progress has been saved successfully!');
        }
    };

    return (
        <div style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '16px',
        }}>
            {/* Title */}
            <h3 style={{
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'black',
                marginBottom: '32px',
            }}>
                Subconscious
            </h3>

            {/* Session Helper Cards Row */}
            <div
                className="subconscious-session-helper-row"
                style={{
                    display: 'flex',
                    flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                    marginBottom: '16px',
                }}
            >
                {/* Left Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>• The subconscious mind holds automatic patterns and beliefs formed from past experiences, quietly shaping daily reactions and hindering or supporting our wellness</div>
                        <div>• It processes vast amounts of information below awareness, influencing physical health through stress responses or intuitive insights.</div>
                        <div>• The subconscious acts as a repository for repressed emotions, which can manifest as blocks if unaddressed.</div>
                        <div>• Reprogramming the subconscious with positive inputs accelerates wellness by aligning inner beliefs with conscious intentions.</div>
                        <div>• It communicates through symbols, dreams, and bodily sensations, offering clues to unresolved conflicts.</div>
                        <div>• The subconscious integrates experiences holistically, promoting wholeness when consciously engaged.</div>
                    </div>
                </div>
                {/* Right Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>1. What automatic thought pops up when you face a familiar challenge, and what deeper belief might it stem from in your subconscious?</div>
                        <div>2. Recall a recent dream or vivid memory; what emotion lingers from it, and how might it reflect a subconscious need for wellness?</div>
                        <div>3. When you notice a physical sensation like tension in your body during stress, what unspoken fear could your subconscious be signaling?</div>
                        <div>4. Think of a habit you want to change; what reward does your subconscious associate with keeping it, even if it's unhelpful?</div>
                        <div>5. If your subconscious could speak directly to you about a current issue, what one word or image comes to mind first?</div>
                        <div>6. What childhood event echoes in your present reactions, and how might exploring it reveal subconscious patterns affecting your wellness?</div>
                    </div>
                </div>
            </div>

            {/* Cards */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                width: '100%',
                maxWidth: '600px',
            }}>
                {/* Card 1 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        Subconscious is another one of those things that I have heard different people define in different ways. The way I think of it is that it's the part of our operating system and beliefs that are not conscious to us. It runs on autopilot and allows us to accomplish things while our conscious mind is doing other things.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        For example, you can walk and still think about what you are talking about because the ability to walk has been programmed into your subconscious. If you think about it, you can know that you once had to learn it and how you learned it has continued on without having to learn it again. Therefore, you know the information is stored somewhere within you.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        Sometimes when we are programmed with something and it slips into our subconscious, we can forget about it. Because we are programmed with our environment up to the age of around 7, there are many things that we adopt into our subconscious that we may not be aware of.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        Whether we are currently aware of what is in our subconscious or not, it does contribute to the reality we experience and our perspective of it. Whenever we have adopted maladaptive ways of coping, or limiting or false beliefs, we can suffer in life. Depending on our soul's intention, the environment we grow up in, and the energy we came to experience life with and through, we may end up having the desire to change some of what is in our subconscious.
                    </p>
                </div>

                {/* Card 2 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        There are many methods for identifying what is in your subconscious:
                    </p>
                    <ol style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'left',
                        lineHeight: '1.5',
                        marginLeft: '16px',
                        marginBottom: '16px',
                    }}>
                        <li>
                            <strong>The Mirror Concept:</strong> Dig into Mirrors on the Quick Reference page. This is the understanding that what you see outside of you will be mirroring something back to you about you. This is not always a direct mirror, but it often is.
                        </li>
                        <li>
                            <strong>Finding the Root Cause:</strong> Whenever we find ourselves in a pattern of thoughts, feelings, or behaviors that we do not wish to continue, there is a way to self-inquire to uncover the root cause of why this pattern exists. This is something that can be explored further in the Self Reflection Session at the top of the Quick Reference page.
                        </li>
                        <li>
                            <strong>Self Inquiry:</strong> When we ask ourselves questions to get at the deep reasons for our decisions, behaviors, and experiences, we can help ourselves to become aware of what is in our subconscious.
                        </li>
                    </ol>
                </div>

                {/* Card 3 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        Reflect on ways to reprogram your subconscious for positive change.
                    </p>
                </div>
            </div>

            {/* Navigation Buttons */}
            <div
                className="subconscious-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px',
                    marginBottom: '16px',
                }}
            >
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goBack}>Back</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goHome}>Home</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={handleSave}>Save</button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .subconscious-nav-btn-row {
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 32px !important;
                        margin-bottom: 16px !important;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Subconscious;
